module.exports = __webpack_public_path__ + "static/media/truck9.749716b0.svg";